import React from 'react'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import Mobile from './Mobile'
import SecondaryLargeNav from './SecondaryLargeNav'
import FollowBar from './FollowBar'

const styles = (theme) => ({
  root: {
    background: theme.palette.primary.main,
    boxShadow: 'none',
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      background: theme.palette.primary.main,
    },
  },
  container: {
    padding: '6px 0',
    margin: 'auto',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      padding: '7px 40px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '4px 15px',
      justifyContent: 'start',
    },
  },
  mobileNavContainer: {
    minWidth: 105,
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  followBar: {
    fontSize: '0.8em',
  },
})

const Secondary = ({ classes, routes, width }) => (
  <div className={classes.root}>
    <div className={classes.container} style={{ maxWidth: width }}>
      <SecondaryLargeNav routes={routes} />
      <div className={classes.mobileNavContainer}>
        <Mobile routes={routes} light />
      </div>
      <div className={classes.followBar}>
        <FollowBar />
      </div>
    </div>
  </div>
)

Secondary.propTypes = {
  classes: PropTypes.object.isRequired,
  routes: PropTypes.shape({
    main: PropTypes.arrayOf(PropTypes.object).isRequired,
    secondary: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  width: PropTypes.number.isRequired,
}

export default withStyles(styles)(Secondary)



// WEBPACK FOOTER //
// ./src/components/Navigation/Secondary.js